import { render, staticRenderFns } from "./RcWidgetLiveResultsAlpha3.vue?vue&type=template&id=409cc13b&"
import script from "./RcWidgetLiveResultsAlpha3.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsAlpha3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports